import { flow, applySnapshot } from 'mobx-state-tree';
import compact from 'lodash/compact';

import api from '~/api';
import { toMapById } from '~/mst/utils';
import type { SearchDataPointsParams } from '~/api/rest/search';
import type { IWindRoseWidgetModel } from './model';

export default (self: IWindRoseWidgetModel) => ({
  fetch: flow(function* fetch(params = {}) {
    try {
      self.startFetching();
      const payload = {
        data_point_id: compact([self.wind_speed_data_point_id, self.wind_direction_data_point_id]),
        node_id: self.node_id,
        ...params
      } as SearchDataPointsParams;
      const { data } = yield self.sync(api.search.nodes, payload);
      applySnapshot(self.nodes, {
        models: toMapById(data)
      });
      self.finishFetching();
    } catch (error) {
      self.failFetching(error);
    }
  })
});
